import { render, staticRenderFns } from "./OrgnzDetailMemo.vue?vue&type=template&id=22b2c487&"
import script from "./OrgnzDetailMemo.vue?vue&type=script&lang=js&"
export * from "./OrgnzDetailMemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports